<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <span class="block" role="status">
    <span
      class="motion-safe:animate-spin block size-full rounded-full border-(length:--spinner-thikness,2.5px) border-current/25 border-t-current"
      aria-hidden="true"
    />
    <span class="sr-only">{{ t("ui.loading") }}</span>
  </span>
</template>
